<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">

          <h5>
            Enrich {{ campaignDescription["campaign_name"] }} Field Data To Master
            Database
          </h5>



        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button @click="finished">Finish</vs-button>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">



          <p class="mt-5">
            These are the list of accounts from master database and accounts from
            campaign.
            Upper is the accounts uploaded for campaign and below accounts are the list from master database.
            Please click accept to enchance data to master database or ignore to do nothing.
          </p>

        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
      </vs-row>

      <vs-pagination :total="total_pages" v-model="currentx" goto></vs-pagination>

      <template v-for="(matched_account, key) in match_accounts">
        <vs-table stripe :key="key" :data="matched_account" class="mt-10">

          <template slot="thead">
            <vs-th>
              Action
            </vs-th>
            <vs-th>Company

            </vs-th>



          </template>

          <template slot-scope="{ data }">
            <vs-tr>
              <vs-td>
                <vs-button @click="acceptToUpdate(matched_account)">Accept</vs-button>
              </vs-td>
              <vs-td>
                {{ matched_account.company }}
              </vs-td>
            </vs-tr>
            <!-- Master DB -->
            <vs-tr>
              <vs-td>
                <vs-button @click="IgnoreUpdateToAccountField(matched_account)">Ignore</vs-button>
              </vs-td>
              <vs-td>
                {{ matched_account.company }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template>
      <vs-pagination :total="total_pages" v-model="currentx" goto></vs-pagination>
    </vx-card>
    <vs-popup fullscreen style="z-index: 999999;" class="holamundo" title="Enrich Field Data To Master Database"
      :active.sync="enrichOtherFieldAccountDataToMasterDBPopUp">
      <div class="text-center">
        <h6 class="mb-2">
          Account : {{ accountDataDescription.company_name ? accountDataDescription.company_name :
            accountDataDescription.company }}
        </h6>
      </div>



      <template v-for="(changes, key, index) in review_changes">

     



        <vs-row vs-w="12">

          <template v-for="(value, ind) in Object.entries(changes)">


            <template v-if="value[1] != null && value[1]['old_value'] != value[1]['new_value']">
              <template v-if="value[1]['new_value'] != null">




                <vs-col vs-type="flex" vs-w="12">
                  <vs-row vs-w="12">
                    <vs-col vs-w="4">
                      <div class="p-6" style="height:110px;" v-if="selected_account_fields.includes(value[0])">
                        <h6 class="mb-6">Field Name ( <span>{{ value[1]['field_from'] }} </span>)</h6>
                        

                        {{ value[0] }} ( {{ value[1]['field_type'] }} ) 
                      </div>
                    </vs-col>
                    <vs-col vs-w="3">
                      <div class="p-6" style="height:110px;" v-if="selected_account_fields.includes(value[0])">
                        <h6 class="mb-6">Updated Value </h6>


                        <template v-if="value[1]['field_type'] == 'checkbox'">

                          <template v-for="val in value[1]['new_value']">
                           
                            <vs-checkbox v-model="value[1]['selected']"  
                :vs-value="
                  val
                " class="mr-4">                            {{ val }}

              </vs-checkbox>
                           
                            <br>
                          </template>

                        </template>

                        <template v-else>


                          {{ value[1]['new_value'] }}


                        </template>



                      </div>
                    </vs-col>


                    <vs-col vs-w="5">
                      <vs-row v-if="selected_account_fields.includes(value[0])">
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                          <div class="p-6" style="height:110px;">
                            <h6 class="mb-6">Original Value </h6>


                            <!-- <template v-for="(v, n, i) in all_other_fields_with_details">


                              <template v-if="value[0] == v['formatted_key']">
                                <div
                                  v-if="v['type'] == 'dropdown' || v['type'] == 'checkbox' || v['type'] == 'choose_one'">

                                  <v-select class="width_class" label="value" v-model="value[1]['old_value']"
                                    :options="JSON.parse(v.values)" name="type" />

                                </div>

                                <div v-if="v['type'] == 'date' || v['type'] == 'number'">
                                  {{ value[1]['old_value'] }}
                                </div>

                                <div v-if="v['type'] == 'textarea' || v['type'] == 'text'">
                                  <vs-textarea class="width_class" v-model="value[1]['old_value']" />
                                </div>







                              </template>

                            </template> -->


                            <template v-if="value[1]['field_type'] == 'checkbox'">

                              <template v-for="val in value[1]['old_value']">
                                <vs-checkbox v-model="value[1]['selected']" 
                :vs-value="
                  val
                " class="mr-4">                            {{ val }}

              </vs-checkbox>


                                <br>
                              </template>

                            </template>

                            <template v-else>


                              {{ value[1]['old_value'] }}


                            </template>





                          </div>
                        </vs-col>


                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">

                          <template v-for="(v, n, i) in all_other_fields_with_details">


                            <template v-if="value[0] == v['formatted_key']">
                              <feather-icon
                                v-if="v['type'] == 'checkbox' || v['type'] == 'text' || v['type'] == 'textarea'"
                                @click="campaignFieldDataAction(changes, v['formatted_key'], 'append')" icon="PlusIcon"
                                class="accept-button mr-5" />
                              <feather-icon @click="campaignFieldDataAction(changes, v['formatted_key'], 'replace')"
                                icon="RepeatIcon" class="accept-button mr-5" />
                              <feather-icon @click="campaignFieldDataAction(changes, v['formatted_key'], 'reject')"
                                class="accept-button mr-5" icon="XIcon" />
                            </template>


                          </template>

                        </vs-col>
                      </vs-row>
                    </vs-col>
                  </vs-row>

                </vs-col>

                
                <vs-divider class="p-5" v-if="selected_account_fields.includes(value[0])" />

              </template>
           
           

            </template>

            
          </template>

        </vs-row>

      </template>
      <div class="text-center">
        <vs-button @click.prevent="submitForm">Submit</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data: () => ({
    configDateTimePicker: {
      enableTime: false,
      dateFormat: "Y-m-d"
    },
    review_changes: [],
    match_accounts: [],
    total_pages: 0,
    limit: 10,
    currentx: 1,
    paginate: { limit: 10, offset: 0 },
    accountDataDescription: {},
    enrichAccountDataToMasterDBPopUp: false,
    enrichOtherFieldAccountDataToMasterDBPopUp: false,
    abilities: null,
    table_name: null,
    log: [],
    dataSource: {},
    campaignDescription: [],
    enrichAccountDataToMasterDB: [],
    all_other_fields_with_details: [],
    selected_account_fields: [],
    all_other_fields_values: [],
  }),
  components: {
    "v-select": vSelect,
    DataGrid,
    flatPickr
  },
  watch: {
    currentx: function (val, oldVal) {
      this.paginate = { limit: 10, offset: (val - 1) * this.limit + 1 };
      this.matchedData();
    },
  },
  methods: {
    submitForm() {


      let data = {}
data.csv_table_ml_id = this.accountDataDescription.ml_id;
data.campaignId = this.campaignId;
let self = this;

this.$store
  .dispatch("accountsManagement/updateOtherFieldAccountData", data)
  .then(res => {
    if (res.data.status == "success") {
      this.$vs.notify({
        color: "success",
        title: "Field Updated",
        text: "The fields was enriched successfully."
      });

      this.enrichOtherFieldAccountDataToMasterDBPopUp = false

      this.matchedData()





      // this.matchedData();
    }
  })
  .catch(err => {
    if (err.response.status === 401) {
      this.$router.replace("/login");
}
})
},
    campaignFieldDataAction(changes, key, action) {
      let self = this;
      let data = {};
      data.key = key
      data.changes = changes
      data.action = action
      data.campaign_id = this.$route.params.campaignId
      this.$store
        .dispatch("campaignsManagement/campaignFieldDataAction", data)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Data Changes",
              text: res.data.message
            });
            this.getAccountOtherFieldsWithDetails()
            this.getOtherFieldData()
            this.matchedData();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    //  getAccountOtherFieldsValues() {
    //   let self = this;
    //   let data = {}
    //   data.account_id = this.accountDataDescription.accepted;
    //   data.campaign_id = this.$route.params.campaignId
    //   self.$store
    //     .dispatch(
    //       "campaignsManagement/getAccountOtherFieldsValues",data
    //     )
    //     .then(response => {
    //       let result = response.data;
    //       self.all_other_fields_values = result

    //       console.log("sdfsdfsdf" , self.all_other_fields_values)

    //     })
    //     .catch(err => {

    //       console.error(err);
    //     });
    // },
    getAccountOtherFieldsWithDetails() {
      let self = this;
      let data = {}
      self.$store
        .dispatch(
          "campaignsManagement/getAllAccountOtherFieldsWithDetails"
        )
        .then(response => {
          let result = JSON.parse(response.data);
          self.all_other_fields_with_details = result


          const uniqueArray = (objects, uniqueBy, keepFirst = true) => {
            return Array.from(
              objects.reduce((map, e) => {
                let key = uniqueBy.map(key => [e[key], typeof e[key]]).flat().join('-')
                if (keepFirst && map.has(key)) return map
                return map.set(key, e)
              }, new Map()).values()
            )
          }

          self.all_other_fields_with_details = uniqueArray(self.all_other_fields_with_details, ["field_id"], true)


          let account_fields = []
          result.forEach(function (ele) {
            account_fields.push(ele.formatted_key)
          })
          self.selected_account_fields = account_fields
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getOtherFieldData() {
      let self = this
      let data = {}
      data.account_id = this.accountDataDescription.accepted;
      data.campaign_id = this.$route.params.campaignId
      this.$store
        .dispatch("campaignsManagement/getCampaignOtherFieldData", data)
        .then(res => {
          self.review_changes = res.data;

          console.log("REVIEW CHANGES", self.review_changes)


          for (var key in self.review_changes[0]) {
            if (typeof self.review_changes[0][key] === 'object' && self.review_changes[0][key] !== null) {
              if (self.review_changes[0][key]['new_value'] != self.review_changes[0][key]['old_value']) {
              }
            }
          }

        })
        .catch(err => {
          console.error(err);
        });
    },
    acceptToUpdate(data) {
      this.accountDataDescription = data;
      console.log(data);

      this.getAccountOtherFieldsWithDetails()
      this.getOtherFieldData()
      this.matchedData()

      this.enrichOtherFieldAccountDataToMasterDBPopUp = true
    },
    finished() {
      this.$router
        .push("/accounts/optionsAfterImportAccountToCampaign/" + this.campaignId)
        .catch(() => { });
    },
    IgnoreUpdateToAccountField(data) {
      let Obj = {}
      Obj.csv_table_ml_id = data.ml_id;
      Obj.campaignId = this.campaignId;

      let self = this;


      this.$store
        .dispatch("accountsManagement/IgnoreUpdateToAccountField", Obj)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Account Ignored",
              text: "This account has been ignored."
            });
            this.matchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    goBack: function () {
      this.$router.go(-1);
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      if (s.startsWith("ml_")) return "";
      if (s === "master_db_account") return "";
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s;
    },
    matchedData() {
      this.paginate.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/accounts/enrich_account_field_data_to_masterdatabase",
          this.paginate
        )
        .then(response => {
          this.match_accounts = JSON.parse(response.data).rows;


          console.log("mamamammaa" , this.match_accounts)
          let total = JSON.parse(response.data).total_pages;
          this.total_pages = Math.round(total / this.limit);
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
  },
  mounted() {
    this.getCampaignDescription()
    this.matchedData();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;

    // this.getAssocaitedAccountsAccounts();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}


.width_class {
  width: 580px;
}

.imput_field {
  width: 500px;
}

.accept-button {
  cursor: pointer;
}
</style>

<style lang="stylus">

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: .75rem 1rem;
}

.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
